import { EnumLanguage } from "../EnumLanguage";
import { UIText } from "../UIText/UIText";

export const getTextByLanguage = (path: any, language: EnumLanguage, noTranslate: boolean = false): string => {
	return path[language] ? path[language] : noTranslate ? null : getTextByLanguage(UIText.translate.noTranslate, language);
};